var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "w-100 h-100", attrs: { id: "login" } }, [
    _c("div", { staticClass: "d-flex justify-center justify-content-center" }, [
      _c(
        "div",
        {
          staticClass:
            "content h-100 d-flex flex-column justify-content-center align-items-center",
          staticStyle: {
            width: "45%",
            "margin-top": "50px",
            transition: "1s all",
          },
        },
        [
          _c(
            "div",
            { staticClass: "content-form", staticStyle: { width: "60%" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [_c("SupsisLogo"), _vm._v(" "), _c("language-switch")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "50px",
                    color: "#183b56",
                    "font-weight": "700",
                    "font-size": "35px",
                  },
                },
                [
                  _c("div", { staticStyle: { "line-height": "1" } }, [
                    _vm._v(_vm._s(_vm.$t("login.passwordForget"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "40px" } }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "font-weight-bold",
                      staticStyle: { color: "#183b56" },
                    },
                    [_vm._v(_vm._s(_vm.$t("login.passwordNewAgain")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "3px" } },
                    [
                      _c(
                        "a-input",
                        {
                          ref: "userNameInput",
                          attrs: {
                            type: _vm.loginForm.hidePassword
                              ? "text"
                              : "password",
                            placeholder: _vm.$t(
                              "login.passwordNewAgainPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.loginForm.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.loginForm, "password", $$v)
                            },
                            expression: "loginForm.password",
                          },
                        },
                        [
                          _c("a-icon", {
                            attrs: { slot: "prefix", type: "lock" },
                            slot: "prefix",
                          }),
                          _vm._v(" "),
                          _c("a-icon", {
                            staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                            attrs: {
                              slot: "suffix",
                              type: _vm.loginForm.hidePassword
                                ? "eye"
                                : "eye-invisible",
                            },
                            on: {
                              click: function ($event) {
                                _vm.loginForm.hidePassword =
                                  !_vm.loginForm.hidePassword
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "15px" } }, [
                  _c(
                    "span",
                    {
                      staticClass: "font-weight-bold",
                      staticStyle: { color: "#183b56" },
                    },
                    [_vm._v(_vm._s(_vm.$t("login.passwordNewAgainTwo")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "3px" } },
                    [
                      _c(
                        "a-input",
                        {
                          ref: "userNameInput",
                          attrs: {
                            type: _vm.loginForm.hidePassword
                              ? "text"
                              : "password",
                            placeholder: _vm.$t(
                              "login.passwordNewAgainPlaceholderTwo"
                            ),
                          },
                          model: {
                            value: _vm.loginForm.repassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.loginForm, "repassword", $$v)
                            },
                            expression: "loginForm.repassword",
                          },
                        },
                        [
                          _c("a-icon", {
                            attrs: { slot: "prefix", type: "lock" },
                            slot: "prefix",
                          }),
                          _vm._v(" "),
                          _c("a-icon", {
                            staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                            attrs: {
                              slot: "suffix",
                              type: _vm.loginForm.hidePassword
                                ? "eye"
                                : "eye-invisible",
                            },
                            on: {
                              click: function ($event) {
                                _vm.loginForm.hidePassword =
                                  !_vm.loginForm.hidePassword
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-between",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-center w-full text-white font-weight-bold",
                        staticStyle: {
                          "border-radius": "8px",
                          padding: "13px 0",
                          "font-size": "15px",
                          width: "100%",
                        },
                        style: {
                          background:
                            _vm.loginForm.password &&
                            _vm.loginForm.repassword &&
                            _vm.loginForm.repassword == _vm.loginForm.password
                              ? "#ec4b1d"
                              : "#C3CAD9",
                        },
                        on: { click: _vm.doResetPassword },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("login.passwordNew")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("hr", { attrs: { color: "#C3CAD9", width: "50%" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { margin: "0px 5px", color: "#183b56" },
                        attrs: { width: "100%" },
                      },
                      [_vm._v(_vm._s(_vm.$t("login.loginAnd")))]
                    ),
                    _vm._v(" "),
                    _c("hr", { attrs: { color: "#C3CAD9", width: "50%" } }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-between w-100",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "w-100 text-white text-center font-weight-bold",
                        staticStyle: {
                          background: "#183b56",
                          "border-radius": "8px",
                          padding: "13px 0",
                          "font-size": "15px",
                        },
                        attrs: { to: "/login" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("login.passwordAndLogin")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }